import React from "react";

export default function QuickReplies({ options, onPick, isAr }) {
  return (
    <div
      className="mt-2 flex flex-wrap gap-2 max-w-[92%]"
      dir={isAr ? "rtl" : "ltr"}
      data-testid="dana-quick-replies"
    >
      {options.map((opt, idx) => (
        <button
          key={opt}
          type="button"
          onClick={() => onPick(opt)}
          data-testid={`dana-quick-reply-${idx}`}
          className="rounded-full border border-emerald/40 bg-white/85 px-3.5 py-1.5 text-xs font-semibold text-emerald-deep hover:bg-emerald hover:text-cream active:scale-95 transition-[background-color,color,transform] duration-200"
          style={{ fontFamily: isAr ? "Cairo" : "Plus Jakarta Sans" }}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
